import { render, staticRenderFns } from "./TalentDashboardBookingRequestsListItem.vue?vue&type=template&id=349460eb"
import script from "./TalentDashboardBookingRequestsListItem.vue?vue&type=script&lang=js"
export * from "./TalentDashboardBookingRequestsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports